/**
 * @Name：admin api模块
 * @Author：syy
 * @description：本文件中编写通用接口，各页面具体接口请在 src/api 中建立文件夹，如：src/api/Author.js 是用户模块使用的api
 */
import request from "@/request";
/* 图形验证码 */
export function getLoginVerifyt(data) {
  return request({
    url : '/management/Login/verify',
    method : "post",
    data
  });
}
/* 登录 */
export function getLogin(data) {
  return request({
    url : '/management/Login/login',
    method : "post",
    data
  });
}
/* 地址管理 */
export function getaddressList(data) {
  return request({
    url : '/management/Housing/address_list',
    method : "post",
    data
  });
}
/* 地址管理是否推荐 */
export function gethomestay_recommend(data) {
  return request({
    url : '/management/Housing/homestay_recommend',
    method : "post",
    data
  });
}


/* 房源列表 */
export function gethousingList(data) {
  return request({
    url : '/management/Housing/housing_list',
    method : "post",
    data
  });
}

/* 管理员列表 */
export function getmanageList(data) {
  return request({
    url : '/management/Member/manage_list',
    method : "post",
    data
  });
}
/* 管理员列表 -- 回显 */
export function getmanageListedit(data) {
  return request({
    url : '/management/Member/manage_edit',
    method : "post",
    data
  });
}
/* 管理员列表 -- 新增 */
export function getmanageListUpdate(data) {
  return request({
    url : '/management/Member/manage_update',
    method : "post",
    data
  });
}
/* 管理员列表 -- 权限下拉 */
export function getmanageListAdd(data) {
  return request({
    url : '/management/Member/manage_add',
    method : "post",
    data
  });
}


/* 订单列表 */
export function getorderList(data) {
  return request({
    url : '/management/Order/order_list',
    method : "post",
    data
  });
}

/* 商户列表--是否推荐 */
export function gethomestay_recommends(data) {
  return request({
    url : '/management/Merchant/homestay_recommend',
    method : "post",
    data
  });
}
/* 商户列表--禁用 */
export function getmerchantDisabled(data) {
  return request({
    url : '/management/Merchant/merchant_disabled',
    method : "post",
    data
  });
}

/* 商户列表--详情 */
export function getmerchantCheck(data) {
  return request({
    url : '/management/Merchant/merchant_check',
    method : "post",
    data
  });
}
/* 商户列表  */
export function getbindmerchantList(data) {
  return request({
    url : '/management/Merchant/merchant_list',
    method : "post",
    data
  });
}

/* 商户审核 */
export function getauditingOperation(data) {
  return request({
    url : '/management/Merchant/auditing_operation',
    method : "post",
    data
  });
}

/* 商户审核 --信息回显 */
export function getauditingCheck(data) {
  return request({
    url : '/management/Merchant/auditing_check',
    method : "post",
    data
  });
}

/* 商户审核 -- 列表*/
export function getmerchantReview(data) {
  return request({
    url : '/management/Merchant/merchant_auditing',
    method : "post",
    data
  });
}
/* 商户审核 -- 添加账号*/
export function getmerchant_add(data) {
  return request({
    url : '/management/Merchant/merchant_add',
    method : "post",
    data
  });
}
/* 商户审核 -- 密码重置*/
export function getreset_password(data) {
  return request({
    url : '/management/Merchant/reset_password',
    method : "post",
    data
  });
}


/* 民警账号管理 */
export function getPoliceList(data) {
  return request({
    url : '/management/Police/police_list',
    method : "post",
    data
  });
}

/* 民警账号管理--添加 */
export function getPoliceListupdate(data) {
  return request({
    url : '/management/Police/police_update',
    method : "post",
    data
  });
}
/* 民警账号管理--编辑回显 */
export function getPoliceListedit(data) {
  return request({
    url : '/management/Police/police_edit',
    method : "post",
    data
  });
}

/* 按钮权限 */
export function getOrderuserRule(data) {
  return request({
    url : '/management/Member/user_rule',
    method : "post",
    data
  });
}

/* 左侧导航 */
export function getMembermodellist(data) {
  return request({
    url : '/management/Member/model_list',
    method : "post",
    data
  });
}

/* 修改密码 */
export function getMemberupdatepwd(data) {
  return request({
    url : '/management/Member/update_pwd',
    method : "post",
    data
  });
}


/* 用户组管理 */
export function getadminGrouplist(data) {
  return request({
    url : '/management/Member/admin_group_list',
    method : "post",
    data
  });
}

/* 用户组管理--回显 */
export function getadminGroupedit(data) {
  return request({
    url : '/management/Member/admin_group_edit',
    method : "post",
    data
  });
}

/* 用户组管理 --添加 */
export function getadminGroupadd(data) {
  return request({
    url : '/management/Member/admin_group_add',
    method : "post",
    data
  });
}

/* 用户组管理 --操作 */
export function getadminGroupupdate(data) {
  return request({
    url : '/management/Member/admin_group_update',
    method : "post",
    data
  });
}

/* 账户管理 */
export function getadminAccount(data) {
  return request({
    url : '/management/Member/admin_account',
    method : "post",
    data
  });
}

/* 系统设置-热门搜索-列表 */
export function getSystempopular(data) {
  return request({
    url : '/management/System/popular',
    method : "post",
    data
  });
}
/* 系统设置-热门搜索-详情回显 */
export function getSystempopular_edit(data) {
  return request({
    url : '/management/System/popular_edit',
    method : "post",
    data
  });
}
/* 系统设置-热门搜索-添加修改 */
export function getSystempopular_update(data) {
  return request({
    url : '/management/System/popular_update',
    method : "post",
    data
  });
}
/* 系统设置-地铁站-列表 */
export function getSystemsubwaystation(data) {
  return request({
    url : '/management/System/subwaystation',
    method : "post",
    data
  });
}
/* 系统设置-地铁站-详情回显 */
export function getSystemsubwaystation_edit(data) {
  return request({
    url : '/management/System/subwaystation_edit',
    method : "post",
    data
  });
}
/* 系统设置-地铁站-添加修改 */
export function getSystemsubwaystation_update(data) {
  return request({
    url : '/management/System/subwaystation_update',
    method : "post",
    data
  });
}
/* 系统设置-景点-列表 */
export function getSystemattractions(data) {
  return request({
    url : '/management/System/attractions',
    method : "post",
    data
  });
}
/* 系统设置-景点-详情回显 */
export function getSystemattractions_edit(data) {
  return request({
    url : '/management/System/attractions_edit',
    method : "post",
    data
  });
}
/* 系统设置-景点-添加修改 */
export function getSystemattractions_update(data) {
  return request({
    url : '/management/System/attractions_update',
    method : "post",
    data
  });
}
/* 系统设置-精选-列表 */
export function getSystemranking(data) {
  return request({
    url : '/management/System/ranking',
    method : "post",
    data
  });
}
/* 系统设置-精选-详情回显 */
export function getSystemranking_edit(data) {
  return request({
    url : '/management/System/ranking_edit',
    method : "post",
    data
  });
}
/* 系统设置-精选-添加修改 */
export function getSystemranking_update(data) {
  return request({
    url : '/management/System/ranking_update',
    method : "post",
    data
  });
}
/* 系统设置-精选-删除 */
export function getSystemranking_del(data) {
  return request({
    url : '/management/System/ranking_del',
    method : "post",
    data
  });
}
/* 系统设置-精选-排序 */
export function getSystemranking_sort(data) {
  return request({
    url : '/management/System/ranking_sort',
    method : "post",
    data
  });
}
/* 系统设置-精选酒店-列表 */
export function getSystemrankinghousing_list(data) {
  return request({
    url : '/management/System/rankinghousing_list',
    method : "post",
    data
  });
}
/* 系统设置-精选酒店-添加列表 */
export function getSystemrankinghousing_add(data) {
  return request({
    url : '/management/System/rankinghousing_add',
    method : "post",
    data
  });
}
/* 系统设置-精选酒店-添加提交 */
export function getSystemrankinghousing_update(data) {
  return request({
    url : '/management/System/rankinghousing_update',
    method : "post",
    data
  });
}
/* 系统设置-精选酒店-排序 */
export function getSystemrankinghousing_sort(data) {
  return request({
    url : '/management/System/rankinghousing_sort',
    method : "post",
    data
  });
}
/* 系统设置-精选酒店-删除 */
export function getSystemrankinghousing_del(data) {
  return request({
    url : '/management/System/rankinghousing_del',
    method : "post",
    data
  });
}
/* 系统设置-精选民宿-列表 */
export function getSystemrankinghomestay_list(data) {
  return request({
    url : '/management/System/rankinghomestay_list',
    method : "post",
    data
  });
}
/* 系统设置-精选民宿-添加列表 */
export function getSystemrankinghomestay_add(data) {
  return request({
    url : '/management/System/rankinghomestay_add',
    method : "post",
    data
  });
}
/* 系统设置-精选民宿-添加提交 */
export function getSystemrankinghomestay_update(data) {
  return request({
    url : '/management/System/rankinghomestay_update',
    method : "post",
    data
  });
}
/* 系统设置-精选民宿-排序 */
export function getSystemrankinghomestay_sort(data) {
  return request({
    url : '/management/System/rankinghomestay_sort',
    method : "post",
    data
  });
}
/* 系统设置-精选民宿-删除 */
export function getSystemrankinghomestay_del(data) {
  return request({
    url : '/management/System/rankinghomestay_del',
    method : "post",
    data
  });
}
/* 系统设置-客服-列表 */
export function getSystemcustomer_service(data) {
  return request({
    url : '/management/System/customer_service',
    method : "post",
    data
  });
}
/* 系统设置-客服-添加 */
export function getSystemcustomer_serviceadd(data) {
  return request({
    url : '/management/System/customer_serviceadd',
    method : "post",
    data
  });
}
/* 系统设置-客服-删除 */
export function getSystemcustomer_servicedel(data) {
  return request({
    url : '/management/System/customer_servicedel',
    method : "post",
    data
  });
}

/* 系统设置-商户推荐-列表 */
export function getSystemrecommend(data) {
  return request({
    url : '/management/System/recommend',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-地区添加 */
export function getSystemrecommend_add(data) {
  return request({
    url : '/management/System/recommend_add',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-民宿推荐列表 */
export function getSystemrecommendhomestay_list(data) {
  return request({
    url : '/management/System/recommendhomestay_list',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-民宿推荐筛选列表 */
export function getSystemrecommendhomestay_add(data) {
  return request({
    url : '/management/System/recommendhomestay_add',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-民宿推荐添加 */
export function getSystemrecommendhomestay_update(data) {
  return request({
    url : '/management/System/recommendhomestay_update',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-民宿推荐排序 */
export function getSystemrecommendhomestay_sort(data) {
  return request({
    url : '/management/System/recommendhomestay_sort',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-民宿推荐删除 */
export function getSystemrecommendhomestay_del(data) {
  return request({
    url : '/management/System/recommendhomestay_del',
    method : "post",
    data
  });
}

/* 系统设置-商户推荐-酒店推荐列表 */
export function getSystemrecommendhotels_list(data) {
  return request({
    url : '/management/System/recommendhotels_list',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-酒店推荐筛选列表 */
export function getSystemrecommendhotels_add(data) {
  return request({
    url : '/management/System/recommendhotels_add',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-酒店推荐添加 */
export function getSystemrecommendhotels_update(data) {
  return request({
    url : '/management/System/recommendhotels_update',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-酒店推荐排序 */
export function getSystemrecommendhotels_sort(data) {
  return request({
    url : '/management/System/recommendhotels_sort',
    method : "post",
    data
  });
}
/* 系统设置-商户推荐-酒店推荐删除 */
export function getSystemrecommendhotels_del(data) {
  return request({
    url : '/management/System/recommendhotels_del',
    method : "post",
    data
  });
}


/* 预警列表 */ 
export function getMemberwarning(data) {
  return request({
    url : '/management/Member/warning',
    method : "post",
    data
  });
}
/* 管辖单位下拉数据 */ 
export function getPolice_add(data) {
  return request({
    url : '/management/Police/police_add',
    method : "post",
    data
  });
}
/* 账号列表-重置密码 */ 
export function getReset_password(data) {
  return request({
    url : '/management/Police/reset_password',
    method : "post",
    data
  });
}
/* 管辖单位-列表 */ 
export function getOrganizations_list(data) {
  return request({
    url : '/management/Police/organizations_list',
    method : "post",
    data
  });
}
/* 管辖单位-详情回显 */ 
export function getOrganizations_edit(data) {
  return request({
    url : '/management/Police/organizations_edit',
    method : "post",
    data
  });
}
/* 管辖单位-添加修改 */ 
export function getOrganizations_update(data) {
  return request({
    url : '/management/Police/organizations_update',
    method : "post",
    data
  });
}

